import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.css";
import Nav from "./nav";

import {

  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge
} from "reactstrap";
import Map from './Map'

var FA = require('react-fontawesome');

export default class TagDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tag: [], loaded: false, open: false };
    this.close = this.close.bind(this);
    this.getBadgeColour = this.getBadgeColour.bind(this);
  }
  componentDidMount() {
    const comp = this;
    fetch(
      "http://www.almotanabbi.com//ws1.0/getTag.do?tagId=" + this.props.tagId
    ).then(response => {
      response.json().then(tag => {
        // alert(JSON.stringify(tag));
        comp.setState({ open: true, loaded: true, tag: tag });
      });
    });
  }
  close() {
    this.setState({ open: false });
    this.props.dialogClosed();
  }
  getBadgeColour(index) {
    const colours = [
      "primary",
      "secondary",
      "success",
      "danger",
      "warning",
      "info",
      "dark"
    ];
    return colours[index % colours.length];
  }

  render() {
    return (
      <div>
        {this.state.loaded && (
          <Modal isOpen={this.state.open}>
            <ModalHeader toggle={this.close}>{this.state.tag.name}
            </ModalHeader>
            <ModalBody>
            {this.state.tag.wikipedia && (
              <a href={this.state.tag.wikipedia} target="_blank">
              <FA name='wikipedia-w' style={{color:'black'}} />
              </a>
            )}

            {this.state.tag.youtube && (
              <a href={this.state.tag.youtube} target="_blank">
                <FA name='youtube' style={{color:'black'}}/>
              </a>
            )}
            {this.state.tag.familyTreePerson &&<a style={{cursor:'pointer'}} onClick={this.props.openFamilyTreeDialog} ><img src="/icons/family_tree.gif"/></a>}
            <br/>
            {this.state.tag.description}
              
              {this.state.tag.tagGeographicalData && <center><hr/><div style={{borderWidth:'1px',borderStyle:'solid',borderWidth:'1px'}}><Map
                position={{ lat: this.state.tag.tagGeographicalData.latitude, lng: this.state.tag.tagGeographicalData.longitude }}
                title={this.state.name}
                zoom={this.state.tag.tagGeographicalData.preferredGmapZoom}
              /></div></center>}
              <hr />
              {this.state.tag.linksList.map(link => (
                <div>
                  <a href={link.url} target="_blank">
                    {link.urlName}
                  </a>
                </div>
              ))}
              <br />
              <hr/>
              {this.state.tag.photosList &&
              <center>
              {this.state.tag.photosList.map((photo, index) => (
                <img src={'http://www.almotanabbi.com/streamTagThumbnail.do?photoId=' + photo.photoId} title={photo.description} height='70' onClick={() => {this.props.openPhotosDialog(this.state.tag.photosList, index)}}/>
              ))}
              </center>}

              <hr />
              <div style={{ textAlign: "center" }}>
                {this.state.tag.namesList.map((name, index) => (
                  <React.Fragment>
                    <Badge color={this.getBadgeColour(index)}>{name}</Badge>&nbsp;
                  </React.Fragment>
                ))}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.close}>
                غلق
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TagDialog.js